import {useCallback} from 'react';

import {SessionTextChat} from 'components';
import {AgentSession, SessionActivityName} from 'interfaces';
import {TextChatMessage, TextChatThreads} from 'types';

type Props = {
    session: AgentSession;
    threads?: TextChatThreads;
    onAsk: (question: string) => Promise<any>;
}

export const AgentChatbot: React.FC<Props> = ({session, threads, onAsk}: Props) => {
    const onSubmitMessage = useCallback((message: Partial<TextChatMessage>) => onAsk(message.content), [onAsk]);

    return (
        <SessionTextChat
            session={session}
            threads={threads}
            activityName={SessionActivityName.AgentChatbot}
            uploadFileHidden
            downloadFileDisabled
            onSubmitMessage={onSubmitMessage}
        />
    );
};
